import { createTailwindMerge, getDefaultConfig, mergeConfigs } from "tailwind-merge"
import { createTV, VariantProps, ClassValue } from "tailwind-variants"

const getConfig = () =>
  mergeConfigs(getDefaultConfig(), {
    extend: {
      classGroups: {
        type: ["type", (val: string) => /^type-/.test(val)],
      },
    },
  })

const cn = createTailwindMerge(getConfig)

const tv = createTV({
  twMergeConfig: getConfig,
})

export { cn, tv }
export type { VariantProps, ClassValue }
